import cssVars from 'css-vars-ponyfill'
import themeUtils from '../../util/themeUtils'

const customize = {
  state: {
    info: null
  },
  actions: {
    setCustomizeInfo (context, info) {
      const profile = info.profile
      if (profile) {
        context.commit('setProfile', profile)
      }
      const color = info.color
      if (color) {
        cssVars({
          variables: {
            '--theme-color': color
          },
          watch: true,
          onlyLegacy: false,
          silent: true
        })
        themeUtils.changeTheme(color)
      }
      context.state.info = info
    }
  }
}

export default customize



// WEBPACK FOOTER //
// ./src/store/modules/customize.js